import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateExercise } from '../../../api/diary-service';
import { useState } from 'react';

const useUpdateExercise = (currentDay) => {
    const [isUpdatingAndSyncing, setIsUpdatingAndSyncing] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: ({ id, data }) => updateExercise(id, data),
        onError: (error) => {
            console.error('Failed to update exercise:', error);
        }
    });

    const updateExerciseAndSync = async (id, payload) => {
        setIsUpdatingAndSyncing(true);

        try {
            await mutation.mutateAsync({ id, data: payload });
            await queryClient.refetchQueries({ queryKey: ['diary', currentDay] });
        } catch (err) {
            console.error('Update and sync failed:', err);
        } finally {
            setIsUpdatingAndSyncing(false);
        }
    };

    return {
        updateExercise: updateExerciseAndSync,
        isUpdating: isUpdatingAndSyncing,
        isSuccess: mutation.isSuccess,
        isError: mutation.isError,
        error: mutation.error,
        reset: mutation.reset
    };
};

export default useUpdateExercise;
